module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/Payments/images/visa-47fbcbdd72bc7a6c37ec1ccfcb1af991.svg";